var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ytSubscribeContainer"},[_c('div',{staticClass:"g-ytsubscribe",attrs:{"data-channelid":"UC2I5xnLIJ-neeuKcMTYQrzg","data-layout":"full","data-theme":"dark","data-count":"default"}})])}
var staticRenderFns = []

export { render, staticRenderFns }